import React, { useEffect } from 'react'
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom"
import { AuthRoutes } from 'AuthRoutes';
import { ProtectedRoutes } from 'ProtectedRoutes';
import { useSelector } from 'react-redux';
import { userSelector } from 'slices/userSlice';
import InterviewInvite from 'views/interview-invite';
import toast from 'react-hot-toast';

export const AppRoutes = () => {
  const { isAuthenticated, user } = useSelector(userSelector);

  return (
    <BrowserRouter>
      {/* Public and Auth Routes */}

      {/* Protected Routes */}
      {isAuthenticated ? 
      <ProtectedRoutes />
       :
        <>
          <AuthRoutes />
          <Routes>  <Route path="/interview-invite" element={<InterviewInvite />} /></Routes>
        </>

      }
      {/* Fallback Route */}
      {/* <Route path="*" element={<Navigate to="/login" replace />} /> */}
    </BrowserRouter>
  )
}
